import { gql, useLazyQuery } from "@apollo/client";

const GET_DESIGNER_APPLICATION_QUERY = gql`
  query GetDesignerApplication($id: String!) {
    getDesignerApplication(designerId: $id) {
      _id
      designerId
      status
      experience {
        id
        title
        company
        startDate
        endDate
        current
        employmentType
        firmSize
      }
      education
      references {
        id
        type
        businessName
        firstName
        lastName
        title
        ProjectType
        email
        phoneNumber
        startDate
        endDate
        yearsKnown
      }
      businessGoals {
        overview {
          numberOfProjectsLastYear
          totalRevenueLastYear
          totalRevenueCurrentYear
          numberOfProjectsCurrentYear
        }
        projectCapacity {
          largeScale
          smallScale
        }
        challenges
        expectations
      }
      membershipTier
      singlePaymentItems
    }
  }
`;

export const useGetDesignerApplicationQuery = (designerId: string) => {
  const [getDesignerApplication, { loading, error, data }] = useLazyQuery(
    GET_DESIGNER_APPLICATION_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const executeQuery = () => {
    return getDesignerApplication({
      variables: { id: designerId }
    });
  };

  return {
    getDesignerApplication: executeQuery,
    loading,
    error,
    data: data?.getDesignerApplication,
  };
};
